import * as z from "zod";

export const getRichpanelConnectionStatus = {
  name: "getRichpanelConnectionStatus" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    smsPhoneNumber: z.nullable(z.string()),
    /** Richpanel rejected our credentials; the merchant must reconnect. */
    needsReauth: z.boolean(),
  }),
};
